//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import api from "@/services/api";
import { server } from "@/services/constants";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";

export default {
  mounted() {
    // if (api.isLoggedIn()) {
    //   this.$router.push("/dashboard");
    // }

    this.$hideLoader();
  },
  components: { SuccessDialog, SuccessDialogPush },
  data() {
    return {
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      dialogAdd: false,
      isShowPassword: false,
      isShowPassword2: false,
      account: {
        password: "",
        confirm_password: "",
      },
    };
  },
  methods: {
    async submit() {
      if (this.account.password == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed!!!",
          "Please Input password",
          "text-h5 red--text text-center"
        );
        return;
      }

      if (this.account.confirm_password == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed!!!",
          "Please Input Confirm Password",
          "text-h5 red--text text-center"
        );
        return;
      }

      if (this.account.password != this.account.confirm_password) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed!!!",
          "Password and Confirm Password not match",
          "text-h5 red--text text-center"
        );
        return;
      }

      const res_reset = await api.resetPassword(
        localStorage.getItem(server.USER_ID),
        this.account
      );
      // alert(res_edit.status);
      if (res_reset.status == 200 || res_reset.status == 201) {
        this.$store.state.global_push_dialog = true;
        this.setupAlertDialogPush(
          true,
          "Success!!!",
          "Update data success",
          "text-h5 green--text text-center",
          "/dashboard"
        );
      } else {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed!!!",
          "Update data Failed",
          "text-h5 red--text text-center"
        );
      }
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
  },
};
